import * as jsPDF from 'jspdf';
import * as html2canvas from "html2canvas";

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { Injectable, ElementRef, Renderer2 } from '@angular/core';
import { Validators } from '@angular/forms';


@Injectable()
export class PdfExporterService {

  constructor(private renderer: Renderer2) { }

  /**
   * Export an html section to pdf file.
   * @param container Container with the component that have a pdf template
   * @param fileName Name of exported file.
   * @param exportOptions options of exported file (measurements)
   */
  async export(container: any, fileName: string, showPrice: boolean) {

    // const content = container.nativeElement;

    const doc = new jsPDF("p", "pt", "letter");

    // const pdfTable = this.pdfTable.nativeElement;
    // let test = "<div><h1> TEST <h1></div>"
    // var html = htmlToPdfmake(content.innerHTML);

    var tipoDocumento = "";
    var clienteProveedor = "";
    var solicita = "";
    var fechaCompromiso = false;
    var contactName = "";
    if (container.saleType === "Cotización") {
      tipoDocumento = "Cotización";
      clienteProveedor = "Cliente";
      solicita = "SOLICITA";
      fechaCompromiso = true;
      contactName = container.contactNameCotizacion;
    }
    else if (container.saleType === "Compra") {
      tipoDocumento = "Compra";
      clienteProveedor = "Proveedor"
      solicita = "TELÉFONO"
      fechaCompromiso = false
      contactName = container.contactName;
    }
    else {
      tipoDocumento = "Venta";
      clienteProveedor = "Cliente"
      solicita = "SOLICITA";
      fechaCompromiso = true
      contactName = container.contactName;
    }

    const isSpecialCompany = container.companyRFC === 'PCD230530KK1' &&
      container.saleTypeId === 3;

    const specialNotes = [
      '• Precios en moneda nacional',
      '• Mas I.V.A.',
      `• Condiciones de pago: ${container.methodPayment || ''}`,
      '• Depósito acreditado a la cuenta',
      '• Existencias salvo previa venta',
      '• Vigencia de cotizacion: 5 días'
    ];

    const documentDefinition = {


      content: [
        {
          columns: [
            {
              image: await this.getBase64ImageFromURL("assets/images/logos/" + container.companyImageName),
              width: 100,
              height: 100
            },
            {
              style: 'table1',
              table: {
                widths: ['*', 'auto'],
                body: [
                  [{ text: container.companyName, style: 'header' }, { text: 'No. ' + tipoDocumento + ': ' + container.saleNumber, alignment: 'right', style: 'header' }],
                  container.companyName != container.fiscalName ? [{ text: container.fiscalName, style: 'header' }, { text: 'MONEDA: ' + container.customerCurrency, alignment: 'right', style: 'header' }] : ['', { text: 'MONEDA: ' + container.customerCurrency, alignment: 'right', style: 'header' }],
                  [{ text: container.companyRFC, style: 'header' }, ''],
                  [{ text: container.companyAddress, style: 'header' }, ''],
                  [{ text: container.companyPostalCode + "," + container.companyCity + "," + container.companyState + "," + container.companyCountry, style: 'header' }, ''],
                  [{ text: container.companyPhone, style: 'header' }, ''],
                  [{ text: container.companyEmail, style: 'header' }, '']
                ]
              },
              layout: 'noBorders'
            }
          ]
        },
        {
          style: 'table2',
          table: {
            widths: [100, '*', 5, 120, '*'],
            body: [
              [{ text: clienteProveedor, style: 'clienteTable' }, { text: container.customerName, alignment: 'right', style: 'tableHeader' }, { text: '', border: [false, false, false, false] }, { text: 'FECHA DE ' + tipoDocumento.toUpperCase(), style: 'clienteTable' }, { text: this.formatFecha(container.saleDate), alignment: 'right', style: 'tableHeader' }],
              [{ text: 'DIRECCIÓN', style: 'clienteTable' }, { text: container.customerAddress, alignment: 'right', style: 'tableHeader' }, { text: '', border: [false, false, false, false] }, { text: 'TIPO', style: 'clienteTable' }, { text: container.saleType, alignment: 'right', style: 'tableHeader' }],
              [{ text: solicita, style: 'clienteTable' }, { text: contactName, alignment: 'right', style: 'tableHeader' }, { text: '', border: [false, false, false, false] }, { text: 'ENTREGA', style: 'clienteTable' }, { text: container.placeOfDelivery, alignment: 'right', style: 'tableHeader' }],
              // [{text: 'ESTATUS ' +tipoDocumento.toUpperCase(), style: 'clienteTable'},{text: container.estatusVenta, alignment: 'right', style: 'tableHeader'},{text:'',border: [false, false, false, false] },{text: 'FECHA COMPROMISO', style: 'clienteTable'},{text: this.formatFecha(container.deliveryCommitmentDate), alignment: 'right', style: 'tableHeader'}],                
              [{ text: 'ESTATUS ' + tipoDocumento.toUpperCase(), style: 'clienteTable' }, { text: container.estatusVenta, alignment: 'right', style: 'tableHeader' }, { text: '', border: [false, false, false, false] }, { text: 'FECHA COMPROMISO', style: 'clienteTable' }, fechaCompromiso ? { text: this.formatFecha(container.deliveryCommitmentDate), alignment: 'right', style: 'tableHeader' } : { text: '', alignment: 'right', style: 'tableHeader' }
              ]
            ]
          }
          // layout: 'noBorders' 
        },
        {//Tabla detalles
          style: 'tableExample',
          table:
            this.createTable(container, showPrice),
        },
        {
          table:
            this.createTableTotales(container, showPrice),
        },
        {
          unbreakable: true,
          style: 'tableExample',
          margin: [0, 10, 0, 0],
          table: {
            widths: ['*'],
            
            body: [
              [{ text: 'NOTAS DE ' + tipoDocumento.toUpperCase(), style: 'clienteTable', alignment: 'center' }],
              [{ text: '', alignment: 'justify', border: [true, false, true, false] }],
              
              [{
                text: isSpecialCompany
                  ? specialNotes.join('\n')
                  : (container.defaultComment != null ? container.defaultComment.toUpperCase() : ""),
                alignment: 'justify',
                border: [true, false, true, false]
              }],


              [{
                text: container.comments != null ? "* " + container.comments.toUpperCase() : "",
                alignment: 'justify',
                fontSize: container.companyName?.toLowerCase().includes('bueno aires')
                  ? 16
                  : 9,
                border: [true, false, true, true]
              }]
            ]
          }
        },

        ...(isSpecialCompany ? [{
          margin: [0, 20, 0, 0],
          text: [
            { text: 'Correo contacto: ' },
            container.sellerEmail || ''
          ],
          alignment: 'left',
          fontSize: 9
        }] : [])

      ],

      styles: {
        tableExample: {
          margin: [0, 5, 0, 15],
          fontSize: 8
        },
        table1: {
          margin: [10, 10, 0, 0]
        },
        tableHeader: {
          bold: true,
          fontSize: 9,
          color: 'black'
        },
        header: {
          bold: true,
          fontSize: 11,
          color: 'black',
          margin: [0, -5, 0, 0]
        },
        tableHeader1: {
          bold: true,
          fontSize: 9,
          color: 'black'
        },
        clienteTable: {
          bold: true,
          fontSize: 9,
          color: 'black',
          fillColor: '#cccccc',
        },
        table2: {
          margin: [0, 10, 5, 10]
        }
      },
      defaultStyle: {
        // columnGap: 20
      },
      pageMargins: [20, 20, 20, 20],
    };

    let x = pdfMake.createPdf(documentDefinition).download(fileName);

    // x.download();

    // html2canvas(content, {scale:1}).then((canvas) => {

    //   //var pageWidth = 595.28;
    //   //var pageHeight = 841.89;

    //   //var imgWidth = 585.28;
    //   //var imgHeight = 821.89;

    //   //! MAKE YOUR PDF
    //   var pdf = new jsPDF("p", "pt", "letter");

    //   var pageWidth = pdf.internal.pageSize.getWidth() ;
    //   var pageHeight = pdf.internal.pageSize.getHeight() ;

    //   var imgWidth = pdf.internal.pageSize.getWidth() - 10;
    //   var imgHeight = pdf.internal.pageSize.getHeight() - 20;

    //   var imgHeightOriginal = (canvas.height * imgWidth / canvas.width);// - 300;

    //   if(imgHeightOriginal < 2000){
    //     imgHeightOriginal = imgHeightOriginal - 300;
    //   }

    //   for (var i = 0; i < imgHeightOriginal/1250; i++) {
    //       //! This is all just html2canvas stuff
    //       var srcImg  = canvas;
    //       var sX      = 0;
    //       var sY      = 1250 * i; // start 820 pixels down for every new page
    //       var sWidth  = canvas.width;
    //       var sHeight = 1250;
    //       var dX      = 0;
    //       var dY      = 0;
    //       var dWidth  = canvas.width;
    //       var dHeight = 1250;

    //       var onePageCanvas = document.createElement("canvas");
    //       onePageCanvas.setAttribute("width", canvas.width);
    //       onePageCanvas.setAttribute("height", "1250");
    //       var ctx = onePageCanvas.getContext('2d');

    //       ctx.drawImage(srcImg, sX, sY, sWidth, sHeight, dX, dY, dWidth, dHeight);
    //       var canvasDataURL = onePageCanvas.toDataURL("image/png");

    //       if (i > 0) {
    //           pdf.addPage(); 
    //       }

    //       pdf.addImage(canvasDataURL, 'PNG', 5, 10, imgWidth, imgHeight);

    //   }

    //   pdf.save(fileName);

    //   // var imgData = canvas.toDataURL('image/png');

    //   // var pageWidth = 595.28;
    //   // var pageHeight = 841.89;

    //   // var imgWidth = 585.28;
    //   // var imgHeight = 821.89;

    //   // var imgHeightOriginal = canvas.height * imgWidth / canvas.width;

    //   // const doc = new jsPDF("p", "pt", "a4");

    //   // doc.addImage(imgData, 'PNG', 5, 10, imgWidth, imgHeightOriginal);

    //   // var paginasExtras = (imgHeightOriginal/pageHeight) - 1
    //   // for(var i = 0; i < paginasExtras; i++){
    //   //   doc.addPage();
    //   //   var position = (-1*(pageHeight * (i + 1))) + 5;
    //   //   doc.addImage(imgData, 'PNG', 5, position, imgWidth, imgHeightOriginal);
    //   // }

    //   //doc.save(fileName);

    // });

  }


  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = error => {
        reject(error);
      };

      img.src = url;
    });
  }

  createTable(container, showPrice) {
    const isSpecialCompany = container.companyRFC === 'PCD230530KK1' &&
      container.saleTypeId === 3;

    let body;

    if (container.hasDiscount == 0) {
      body = {
        widths: isSpecialCompany
          ? [44, 'auto', '*', 'auto', 'auto', 'auto', 50]
          : [50, 'auto', '*', 'auto', 'auto', 'auto'],
        dontBreakRows: true, body: [
          [{ text: 'CANTIDAD', style: 'tableHeader1', fillColor: '#cccccc' },
          { text: 'UNIDAD', style: 'tableHeader1', fillColor: '#cccccc' },
          { text: 'NOMBRE', style: 'tableHeader1', fillColor: '#cccccc' },
          { text: 'CÓDIGO', style: 'tableHeader1', fillColor: '#cccccc' },
          { text: 'PRECIO UNITARIO', style: 'tableHeader1', fillColor: '#cccccc' },
          { text: 'TOTAL', style: 'tableHeader1', fillColor: '#cccccc' },

          ...(isSpecialCompany ? [{
            text: 'ENTREGA',
            style: 'tableHeader1',
            fillColor: '#cccccc',
            alignment: 'center'
          }] : [])
          ]

        ]
      };
    } else {
      body = {

        widths: isSpecialCompany
          ? [45, 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 50]
          : [50, 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto'],

        dontBreakRows: true, body: [
          [{ text: 'CANTIDAD', style: 'tableHeader1', fillColor: '#cccccc' },
          { text: 'UNIDAD', style: 'tableHeader1', fillColor: '#cccccc' },
          { text: 'NOMBRE', style: 'tableHeader1', fillColor: '#cccccc' },
          { text: 'CÓDIGO', style: 'tableHeader1', fillColor: '#cccccc' },
          { text: 'PRECIO UNITARIO', style: 'tableHeader1', fillColor: '#cccccc' },
          { text: 'SUBTOTAL', style: 'tableHeader1', fillColor: '#cccccc' },
          { text: 'DESCUENTO', style: 'tableHeader1', fillColor: '#cccccc' },
          { text: 'TOTAL', style: 'tableHeader1', fillColor: '#cccccc' },

          ...(isSpecialCompany ? [{
            text: 'ENTREGA',
            style: 'tableHeader1',
            fillColor: '#cccccc',
            alignment: 'center'
          }] : [])
          ]
        ]
      };
    }

    container.details.forEach(detail => {
      if (container.hasDiscount == 0) {
        body.body.push([
          { text: detail.quantity },
          { text: detail.unidadMedida },
          { text: detail.productName },
          { text: detail.SKU },
          { text: this.isShowPriceHasDiscount(showPrice, container.hasDiscount, detail), alignment: 'right', margin: [10, 0, 0, 0] },
          { text: this.isShowPriceHasDiscountTotal(showPrice, container.hasDiscount, detail), alignment: 'right', margin: [10, 0, 0, 0] },

          ...(isSpecialCompany ? [{
            text: detail.deliveryLegend || '',
            alignment: 'left',
            fontSize: 8
          }] : [])

        ]);
      } else {
        body.body.push([
          { text: detail.quantity },
          { text: detail.unidadMedida },
          { text: detail.productName },
          { text: detail.SKU },
          { text: this.isShowPriceHasDiscount(showPrice, container.hasDiscount, detail), alignment: 'right', margin: [10, 0, 0, 0] },
          { text: this.isShowPrice(showPrice, detail.subtotal), alignment: 'right', margin: [10, 0, 0, 0] },
          { text: this.isShowPrice(showPrice, detail.amountDiscount), alignment: 'right', margin: [10, 0, 0, 0] },
          { text: this.isShowPriceHasDiscountTotal(showPrice, container.hasDiscount, detail), alignment: 'right', margin: [10, 0, 0, 0] },

          ...(isSpecialCompany ? [{
            text: detail.deliveryLegend || '',
            alignment: 'left',
            fontSize: 8
          }] : [])


        ]);
      }
    });

    return body;
  }

  createTableTotales(container, showPrice) {
    const isSpecialCompany =
      container.companyRFC === 'PCD230530KK1' &&
      container.saleTypeId === 3;

        // NUEVA EMPRESA
  const isAnotherCompany =
    container.companyRFC === 'GARA760617FG8';

    let texto = ''
    if (container.saleType === "Compra") {
      texto = ''

    }
    else if (container.saleType === "Cotización") {
      // EMPRESA ESPECIAL EXISTENTE
      if (isSpecialCompany) {

        texto = '';

      }
      // NUEVA EMPRESA CON MENSAJE PERSONALIZADO
      else if (isAnotherCompany) {

        texto = 'La presente cotización está sujeta a cambios sin previo aviso.';

      }
      // COMPORTAMIENTO NORMAL
      else {

        texto = 'La presente cotización tiene una vigencia de 15 días naturales a partir de su emisión y está sujeta a cambios sin previo aviso.';

      }
    }
    else {
      texto = 'Debo (mos) y Pagaré (mos) incondicionalmente a la orden de ' + container.companyName + ', en ' + container.companyCity + ', ' + container.companyState + ' el importe total que ampara este documento correspondiente al valor de la mercancía recibida a mi (nuestra) entera satisfacción. Si no fuera pagado a su vencimiento quedo (amos) obligado (s) a pagar intereses moratorios del 4% mensual. La firma en cualquier lugar de este documento se considera como aceptación de este pagaré.'

    }
    let body;

    let lineasTexto;

    if (container.PDF_SIN_IVA == 'Y') {
      lineasTexto = [
        [{ text: texto, rowSpan: 4, fontSize: 8, border: [false, false, false, false], alignment: 'justify' }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }],
        [{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }],
        [{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }],
        [{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }]
      ];
    } else {

      lineasTexto = [
        [{ text: texto, rowSpan: 4, fontSize: 8, border: [false, false, false, false], alignment: 'justify' }, { text: '', border: [false, false, false, false] }, { text: 'SUBTOTAL', fillColor: '#cccccc', fontSize: 10 }, { text: this.isShowPrice(showPrice, container.subtotal), fontSize: 10, alignment: 'right' }],
        [{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }],
        [{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: 'IVA', fillColor: '#cccccc', fontSize: 10 }, { text: this.isShowPrice(showPrice, container.IVA), fontSize: 10, alignment: 'right' }],
        [{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }]
      ];
    }

    if (container.hasDiscount == 0) {
      body = {
        widths: ['*'], dontBreakRows: true, dontBreakColumns: true, body: [
          [{
            table: {
              widths: [300, '*', 100, 'auto'], dontBreakRows: true, dontBreakColumns: true, body: [
                //originales
                // [{text:texto,rowSpan:4 ,fontSize: 8, border: [false, false, false, false], alignment: 'justify'},{text:'',border: [false, false, false, false] },{text: 'SUBTOTAL', fillColor: '#cccccc', fontSize: 10},{text: this.isShowPrice(showPrice,container.subtotal), fontSize: 10, alignment: 'right'}],
                // [{text:'', border: [false, false, false, false]},{text:'',border: [false, false, false, false] },{text: '',border: [false, false, false, false]},{text:'',border: [false, false, false, false]}],
                // [{text:'', border: [false, false, false, false]},{text:'',border: [false, false, false, false] },{text: 'IVA', fillColor: '#cccccc', fontSize: 10},{text:this.isShowPrice(showPrice,container.IVA), fontSize: 10, alignment: 'right'}],
                // [{text:'', border: [false, false, false, false]},{text:'',border: [false, false, false, false] },{text: '',border: [false, false, false, false]},{text:'',border: [false, false, false, false]}],
                //nuevos
                // [{text:texto,rowSpan:4 ,fontSize: 8, border: [false, false, false, false], alignment: 'justify'},{text:'',border: [false, false, false, false] },{text:'',border: [false, false, false, false] },{text:'',border: [false, false, false, false] }],
                // [{text:'', border: [false, false, false, false]},{text:'',border: [false, false, false, false] },{text: '',border: [false, false, false, false]},{text:'',border: [false, false, false, false]}],
                // [{text:'', border: [false, false, false, false]},{text:'',border: [false, false, false, false] },{text:'',border: [false, false, false, false] },{text:'',border: [false, false, false, false] }],
                // [{text:'', border: [false, false, false, false]},{text:'',border: [false, false, false, false] },{text: '',border: [false, false, false, false]},{text:'',border: [false, false, false, false]}],
                ...lineasTexto,

                [{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: 'TOTAL', fillColor: '#cccccc', fontSize: 10 }, { text: this.isShowPrice(showPrice, container.total), fontSize: 10, alignment: 'right' }],
                [{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }],
                [{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: 'GENERACIÓN POR', fillColor: '#cccccc', fontSize: 10 }, {
                  text: container.sellerName?.includes('Nelida') ? '' : container.sellerName,
                  fontSize: 10,
                  alignment: 'right'
                }],
                [{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }],

                [{
                  text: '', border: [false, false, false, false],
                  table: {
                    widths: [20, '*', 20],
                    body: [
                      [
                        { text: '', border: [false, false, false, false] },
                        { text: '', border: [false, false, false, true], margin: [0, 0, 0, 50] }
                      ],
                      [
                        { text: '', border: [false, false, false, false] },
                        { text: 'Nombre y Firma', alignment: 'center', border: [false, false, false, false], margin: [0, 10, 0, 0] }
                      ]
                    ]
                  }

                }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }],
              ]
            }
            , border: [false, false, false, false]
          }],
        ]
      };
    } else {
      body = {
        widths: ['*'], dontBreakRows: true, dontBreakColumns: true, body: [
          [{
            table: {
              widths: [300, '*', 100, 'auto'], dontBreakRows: true, dontBreakColumns: true, body: [
                [{ text: texto, rowSpan: 8, fontSize: 10, border: [false, false, false, false], alignment: 'justify' }, { text: '', border: [false, false, false, false] }, { text: 'SUBTOTAL', fillColor: '#cccccc', fontSize: 10 }, { text: this.isShowPrice(showPrice, container.subtotal), fontSize: 10, alignment: 'right' }],
                [{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }],
                [{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: 'IVA (INCLUIDO)', fillColor: '#cccccc', fontSize: 10 }, { text: this.isShowPrice(showPrice, container.IVA), fontSize: 10, alignment: 'right' }],
                [{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }],
                [{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: 'DESCUENTO', fillColor: '#cccccc', fontSize: 10 }, { text: this.isShowPrice(showPrice, container.amountDiscount), fontSize: 10, alignment: 'right' }],
                [{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }],
                [{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: 'TOTAL', fillColor: '#cccccc', fontSize: 10 }, { text: this.isShowPrice(showPrice, container.total), fontSize: 10, alignment: 'right' }],
                [{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }],


                [{
                  text: '', border: [false, false, false, false],
                  table: {
                    widths: [20, '*', 20],
                    body: [
                      [{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, true], margin: [0, 0, 0, 50] }, { text: '', border: [false, false, false, false] }]
                    ]
                  },
                }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }],
              ]
            }
            , border: [false, false, false, false]
          }],
        ]
      };
    }

    return body;
  }

  isShowPrice(showPrice, precio) {
    const formatterDolar = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    })
    let valor

    if (showPrice == true) {
      return formatterDolar.format(precio);
    } else {
      return '--';
    }

  }

  isShowPriceHasDiscount(showPrice, hasDiscount, detail) {

    if (!showPrice) {
      return '--'
    } else {
      if (hasDiscount == 0) {
        return this.isShowPrice(showPrice, detail.priceNoDiscount);
      } else {
        return this.isShowPrice(showPrice, detail.price);
      }
    }
  }

  isShowPriceHasDiscountTotal(showPrice, hasDiscount, detail) {

    if (!showPrice) {
      return '--'
    } else {
      if (hasDiscount == 0) {
        return this.isShowPrice(showPrice, detail.totalNoDiscount);
      } else {
        return this.isShowPrice(showPrice, detail.total);
      }
    }
  }

  formatFecha(fecha) {
    var date = new Date(fecha);


    let formatted_date = this.agregarCeroMesDia(date.getDate()) + "/" + this.agregarCeroMesDia((date.getMonth() + 1)) + "/" + date.getFullYear()
    return formatted_date;
  }

  agregarCeroMesDia(numero) {

    switch (numero) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
        return '0' + numero;
      default:
        return numero;
    }


  }
}

interface CanvasOptions {
  xCoordinate: number;
  yCoordinate: number;
  width: number;
  height: number;
}



// WEBPACK FOOTER //
// ./src/app/venta/service/pdf-exporter.service.ts